import DroppableView from '../../droppable/Droppable.view';
import { useCanvasController } from '../Canvas.controller';
import canEditMarket from '../../../security/CanEditMarket';
import TemplateView from '../../template/Template.view';
import DraggableView from '../../draggable/Draggable.view';
import type CanvasProperties from '../Canvas.properties.ts';

export default function CanvasDesktopView(props: CanvasProperties) {
  const { handleRightClickOpenDetails, handleRightClickOpenEdit, enableDragAndDropMarketArea } =
    useCanvasController(props);

  return (
    <div>
      <DroppableView id="droppable-container">
        {props.marketComponents &&
          props.marketComponents.map((marketComponent, index) => (
            <DraggableView
              key={index}
              id={marketComponent.id?.toString() ?? '0'}
              marketComponentDetails={marketComponent}
              disabled={!canEditMarket() || !enableDragAndDropMarketArea}
            >
              <TemplateView
                marketComponent={marketComponent}
                onClickOpenDetails={(event) => handleRightClickOpenDetails(event, marketComponent)}
                onClickOpenEdit={(event) => handleRightClickOpenEdit(event, marketComponent)}
              />
            </DraggableView>
          ))}
      </DroppableView>
    </div>
  );
}
